import Cookies from 'js-cookie';
import { CURRENT_REGION_URL_KEY } from '../consts/regions';

export const getCurrentRegionUrl = (): string =>
  window?.BX?.City?.SITE_DIR ||
  Cookies.get(CURRENT_REGION_URL_KEY) ||
  '/';
